export default "__VITE_ASSET__B7YMs_DL__"